import $ from 'jquery';
import rimg from 'rimg-shopify';
import CurrencyConverter from 'shopify-currency-converter';
import AsyncView from 'shopify-asyncview';

import ProductGridItem from '../components/ProductGridItem';
import SearchForm from '../components/search/SearchForm';

export default class StaticSearch {
  constructor(section) {
    this.section = section;
    this.responseContainer = this.section.el.querySelector('[data-html]');
    this.$el = $(section.el);
    this.searchFieldSelector = '[data-live-search]';
    this.paginationSelector = 'a.pagination--item';
    this.$searchField = this.$el.find(this.searchFieldSelector);
    this.paginationLinks = this.section.el.querySelectorAll(this.paginationSelector);
    this.ajaxEvents = [];
    this.processing = false;

    this._ajaxFetch = this._ajaxFetch.bind(this);
    this._initProducts = this._initProducts.bind(this);

    this.paginationLinks.forEach((el) => {
      this.ajaxEvents.push(
        $(el).on('click', this._ajaxFetch),
      );
    });

    // Product items
    this.productItems = [];
    this._initProducts();

    this._updatePrices();
    this.searchForm = new SearchForm(this.$searchField);

    window.onpopstate = (event) => { this._ajaxFetch(event) };
  }

  _ajaxFetch(event) {
    event.preventDefault();
    event.stopPropagation();

    let fetchUrl;
    let pageNumber;

    if (event.type == 'popstate') {
      fetchUrl = event.state.path;
      pageNumber = event.state.toPage;
    } else {
      fetchUrl = event.currentTarget
        .getAttribute('href')
        .replace('&view=undefined', '');
      pageNumber = event.currentTarget.getAttribute('data-to-page');
    }

    this.processing = true;
    this.responseContainer.classList.add('processing');

    AsyncView.load(fetchUrl)
      .done(({html, options}) => {

        Shopify.queryParams.page = pageNumber;

        this.ajaxEvents.forEach($el => $el.off('click', this._ajaxFetch));
        this.ajaxEvents = [];

        this.responseContainer.innerHTML = html;

        this.searchForm.unload();
        this.$searchField = this.$el.find(this.searchFieldSelector);
        this.searchForm = new SearchForm(this.$searchField);

        rimg.watch(this.responseContainer);
        this._initProducts();

        this.paginationLinks = this.section.el.querySelectorAll(this.paginationSelector);

        this.paginationLinks.forEach((el) => {
          this.ajaxEvents.push(
            $(el).on('click', this._ajaxFetch),
          );
        });

        if (event.type != 'popstate') {

          const newUrl = `${window.location.protocol}//${window.location.host}${fetchUrl}`;

          window.history.pushState({ path: fetchUrl, toPage: pageNumber }, '', newUrl);
        }

        $("html, body").animate({ scrollTop: 0 }, "slow");

        this.responseContainer.classList.remove('processing');
      });

  }

  _initProducts() {
    if (this.productItems.length > 0) {
      this.productItems.forEach((productItem) => {
        productItem.unload();
      });

      this.productItems = [];
    }

    const $productItems = this.$el.find('[data-product-item]');

    $productItems.each((i, productItem) => {
      this.productItems.push(
        new ProductGridItem({
          $el: $(productItem),
          id: this.section.id
        })
      );
    });
  }

  onSectionUnload() {
    this.searchForm.unload();

    this.productItems.forEach((productItem) => {
      productItem.unload();
    });
  }

  _updatePrices() {
    this.$el.find('.money').each((index, el) => CurrencyConverter.update(el));
  }
}
